import { useEffect, useState } from 'react'
import { useMutation } from 'react-query';
import { useParams } from 'react-router-dom';
import apiClient from '../../api';
import { Alert, Container } from 'react-bootstrap';
import SpinnerFullScreen from '../Other/SpinnerFullScreen';

function ConfirmNewEmail() {
	const [message, setMessage] = useState<string | null>(null);
	const [error, setError] = useState<string | null>(null);
	const {resetToken} = useParams();

	const mutation = useMutation(
		async (body:{resetToken: string}) => {
		  const response = await apiClient.post("/auth/confirm-email", body);
		  return response.data;
		},
		{
		  onSuccess: (data: any) => {
			setMessage(data?.message || "Password reset successfully");
			setError(null);
		  },
		  onError: (error: any) => {
			setMessage(null);
			setError("Something went wrong, please try again or contact admin.");
		  },
		}
	  );

	useEffect(()=>{
		if(resetToken) {
			mutation.mutate({resetToken});
			// console.log(resetToken);
		} else {
			setError("Invalid reset token");
		}
	}, [resetToken]);
	
	return (
		<Container className="mt-5"  style={{ maxWidth: '500px' }}>
			{mutation.isLoading && <SpinnerFullScreen/>}
			{message && <Alert variant="success">{message}</Alert>}
			{error && <Alert variant="danger">{error}</Alert>}
		</Container>
	)
}

export default ConfirmNewEmail